import { httpGetRequest } from "clients/phronesisClient"
import { SummaryTableData } from "../SummaryTable/SummaryTable.domain"

const BENCHMARK_REACH_ENDPOINT = "/transactional/commercial-benchmark/reach"
const NUMBER_OF_RETRIES = 0

export const getReachSummary = async (
	filters: any
): Promise<SummaryTableData> => {
	return httpGetRequest<SummaryTableData>(
		BENCHMARK_REACH_ENDPOINT,
		filters,
		undefined,
		undefined,
		undefined,
		NUMBER_OF_RETRIES
	)
}
